import getDisplaySwitchingStatus from "./getDisplaySwitchingStatus";

function checkStatusCp (id, switching_status) {
    if (switching_status !== "open")
        return [id, true, getDisplaySwitchingStatus(switching_status)];
    return [id, false, getDisplaySwitchingStatus(switching_status)];
}

export default checkStatusCp;